module.exports = __webpack_public_path__ + "static/media/fb.479bc994.svg";